<template>
	<div>
		<header class="page-title">
			<h2>Translations Editor</h2>
			<div class="ml-auto">
				<button @click="showCreateModal" class="btn btn-md btn-success" v-show="userRoles.includes('site_content.update') && !userRoles.includes('users.translator')">
					<i class="fas fa-plus"></i> New Translation
				</button>
			</div>
		</header>
		<list-renderer :id="'translationLister'" :apiUrl="'/api/' + $selectedSite.slug + '/translations/lister'" :filterIn="filterIn" :listInData="'translations'" :listType="'general'" :orderBy="orderBy" :orderByRules="orderByRules" :showOnly="showOnly" :limit="'25'" :additionalFilters="additionalFilters">
			<template #header="{title}">
			</template>
			<template #content='{list}'>
				<div class="table-lister table-responsive">
					<table class="comments">
						<thead>
							<tr>
								<th><i title="important" class="fa fa-exclamation-triangle"></i></th>
								<th>Group</th>
								<th>Key</th>
								<th>Original</th>
								<th>Translation Status</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="translation in list">
								<td>
									<i v-if="translation.important" title="important" class="translation important fa fa-exclamation-triangle"></i>
								</td>
								<td>{{ translation.group }}</td>
								<td>{{ translation.key }}</td>
								<td>{{ translation.original }}</td>
								<td class="nowrap">
									<ul class="translation-languages">
										<li :class="[translation.translations.hasOwnProperty(language.locale) ? 'badge-success' : 'badge-danger']"
											:title="[translation.translations.hasOwnProperty(language.locale) ? 'Translation in place' : 'Missing translation']"
											class="badge"
											v-for="language in availableLanguages"
											v-if="!selectedAdditionalFilters.hasOwnProperty('languages') || selectedAdditionalFilters.hasOwnProperty('languages') && selectedAdditionalFilters.languages === language.locale"
										>
											{{ language.locale }}
										</li>
									</ul>
								</td>
								<td class="nowrap">
									<a @click="editTranslation(translation)" class="btn btn-icon btn-primary" href="#" title="Edit" v-show="userRoles.includes('site_content.update')"><i class="fas fa-fw fa-pencil-alt"></i></a>
									<a @click="deleteTranslation(translation)" class="btn btn-icon btn-danger" href="#" title="Delete" v-show="userRoles.includes('site_content.delete') && !userRoles.includes('users.translator')"><i class="fas fa-fw fa-trash"></i></a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-renderer>

		<modal @close="closeCreateModal" v-show="isEditModalVisible">
			<template slot="header">
				<h4 v-if="selectedTranslation.id !== null" class="modal-title">New Translation</h4>
				<h4 v-if="selectedTranslation.id === null" class="modal-title">Edit Translation</h4>
			</template>
			<template slot="body">
				<div class="flex box start">
					<div class="form-group five-md">
						<label for="group">Group</label>
						<vue-select
								:options="groups"
								id="group"
								name="group"
								taggable
								v-model="selectedTranslation.group">
						</vue-select>
					</div>
					<div class="form-group five-md">
						<label for="key">Key</label>
						<input id="key" type="text" v-model="selectedTranslation.key">
					</div>
					<div class="form-group two-md">
						<label for="key">Important</label>
						<input id="important" type="checkbox" v-model="selectedTranslation.important">
					</div>
				</div>
				<div class="card mt-1 mb-0">
					<header class="card-header language-list">
						<lang-selector></lang-selector>
					</header>
					<div class="card-body">
						<div class="form-group">
							<label for="value">Text</label>
							<input id="value" type="text" v-model="selectedTranslation[clickedLang].value">
						</div>
					</div>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeCreateModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i class="fas fa-times"></i> Cancel</a>
				<a v-if="selectedTranslation.id === null" @click="createTranslation" class="btn btn-md btn-success" href="#"><i class="fas fa-check"></i> Add New Translation</a>
				<a v-if="selectedTranslation.id !== null" @click="saveTranslation" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>
	</div>
</template>

<script>
import {eventBus} from "../../app";
import modal from "../Modal/DefaultModal.vue";
import VueSelect from '../../../../node_modules/vue-select';
import Errors from '../../Utils/Errors.js';

export default {
	components: {
		modal,
		VueSelect
	},
	props: {
		dataShowOnly: {
			type: Object
		},
		dataEndpoint: {
			type: String
		},
		dataUrlParams: {
			type: Object,
			required: false
		},
		dataSelectedSite: {
			type: Object
		}
	},
	data() {
		return {
			userRoles: this.$currentUserRoles,
			filterIn: ['group', 'key', 'original'],
			orderBy: ['group', 'key'],
			orderByRules: ['asc', 'asc'],
			showOnly: typeof this.dataShowOnly !== 'undefined' && Object.keys(this.dataShowOnly) > 0 ? this.dataShowOnly : {},
			timestamp: Math.floor(Date.now() / 1000),
			additionalFilters: {
				important: {
					elements: [true, false],
					elementsValue: null,
					elementsLabel: null,
					width: 2,
					filterIn: 'important',
					default: null,
				},
				languages: {
					elements: this.$availableLanguages,
					elementsValue: 'locale',
					elementsLabel: 'title',
					width: 2,
					filterIn: null,
					default: null,
					orderBy: ['title'],
					orderByRules: ['asc'],
				}
			},
			selectedAdditionalFilters: {},

			availableLanguages: this.$availableLanguages,
			isEditModalVisible: false,
			clickedLang: this.$defaultLanguage.locale,

			groups: [],
			translationList: [],

			selectedTranslation: {
				id: null,
				key: null,
				group: null,
				important: false,
			},
			errors: new Errors(),
		}
	},
	created() {
		let vm = this;

		for (let i = 0; i < vm.$availableLanguages.length; i++) {
			vm.selectedTranslation[vm.$availableLanguages[i].locale] = {
				value: ''
			};
		}

		eventBus.$on('setActiveStatus', function (clickedLang) {
			vm.clickedLang = clickedLang;
		});

		eventBus.$on('listRendererData', function (data) {
			vm.processListRendererData(data);
		});

		eventBus.$on('additionalFilterChange', function (name, filter, value) {
			vm.additionalFilterChange(name, filter, value);
		});
	},
	methods: {
		additionalFilterChange(name, filter, value) {
			if (value === null) {
				Vue.delete(this.selectedAdditionalFilters, name);
			} else {
				this.selectedAdditionalFilters[name] = value;
			}
		},
		processListRendererData: function (data) {
			if (data.hasOwnProperty('groups')) {
				this.groups = data.groups;
			}
		},
		showCreateModal: function () {
			this.isEditModalVisible = true;
		},
		closeCreateModal: function () {
			let options = {
				keepPage: true
			}
			eventBus.$emit('listRenderer-fetch', options);
			this.isEditModalVisible = false;
			this.clickedLang = this.$defaultLanguage.locale;
		},
		createTranslation: function () {
			let vm = this;
			axios.post('/api/' + vm.$selectedSite.slug + '/translations', vm.selectedTranslation)
					.then(response => {
						this.$toastr.success('New translation saved.');
						vm.closeCreateModal();
					})
					.catch(e => {
						this.errors.record(e.response.data);
						this.$toastr.error('Save new translation failed.', 'Error');
					});
		},
		editTranslation: function (translation) {
			let vm = this;

			vm.selectedTranslation = translation;

			for (let i = 0; i < vm.$availableLanguages.length; i++) {
				vm.selectedTranslation[vm.$availableLanguages[i].locale] = {
					value: translation.translations.hasOwnProperty(vm.$availableLanguages[i].locale)
							? translation.translations[vm.$availableLanguages[i].locale].value : ''
				};
			}

			eventBus.$emit('pushActiveStatus', this.$defaultLanguage);
			this.clickedLang = this.$defaultLanguage.locale;
			vm.isEditModalVisible = true;
		},
		saveTranslation: function () {
			let vm = this;
			axios.put('/api/' + vm.$selectedSite.slug + '/translations/' + vm.selectedTranslation.id, vm.selectedTranslation)
				.then(response => {
					this.$toastr.success('Translation updated successfully.');
					let options = {
						keepPage: true
					}
					eventBus.$emit('listRenderer-fetch', options);
					vm.closeCreateModal();
				})
				.catch(e => {
					this.errors.record(e.response.data);
					this.$toastr.error('Save translation failed.', 'Error');
				});
		},
		deleteTranslation: function (translation) {
			let vm = this;

			this.$dialog.confirm('Are you sure you want to delete this translation?', {
				loader: true
			})
				.then((dialog) => {
					axios.delete('/api/' + vm.$selectedSite.slug + '/translations/' + translation.id,)
						.then(function () {
							dialog.close();
							vm.$toastr.success('Translation deleted successfully.');
							let options = {
								keepPage: true
							}
							eventBus.$emit('listRenderer-fetch', options);
						})
						.catch(function () {
							dialog.close();
							vm.$toastr.error('Deleting translation failed.', 'Error');
						});
				})
				.catch(() => {
					this.$toastr.error('Delete aborted.');
				});
		},
	}
}
</script>

<style>
.important.translation {
	color: #E6393;
}
</style>
